<template>
  <div
    class="page-container"
    :class="{
      'page-container__h5': isH5,
      'page-container__electron': isElectron,
    }"
  >
    <div class="header" v-if="!isElectron">
      <span v-if="!isH5">评价完成</span>
      <span class="header-back" @click="back"></span>
    </div>
    <!-- <span class="header-back" @click="back" v-if="isElectron"></span> -->
    <div class="page-content">
      <img src="../../assets/images/comment/comment-complete.png" alt="" />
      <p>评价完成</p>
      <div class="btn-box">
        <div class="view-btn" @click="viewComment">查看评价</div>
        <div class="goon-btn" @click="goToComment">继续评价</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  name: "CommentComplete",
  data() {
    return {
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    back() {
      window.history.go(-2);
    },
    // 查看评价详情页
    viewComment() {
      if (this.$route.params.comment_id) {
        this.$router.push({
          name: "CommentInfo",
          params: {
            id: this.$route.params.comment_id,
          },
        });
      }
    },
    // 继续评价
    goToComment() {
      this.$router.push({
        name: "CommentList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 100px;
  .header {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: $saas-text-color;
    background: #ffffff;
    position: relative;
    .header-back {
      position: absolute;
      width: 9px;
      height: 13px;
      top: 50%;
      left: 50%;
      transform: translate(-400px, -50%);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      background-image: url("../../assets/images/group-activity/back-icon.png");
      cursor: pointer;
    }
  }
  .page-content {
    width: 800px;
    height: 495px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 120px;
      height: 120px;
      margin-top: 100px;
    }
    p {
      margin-top: 20px;
      font-weight: 600;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
    }
    .btn-box {
      margin-top: 110px;
      display: flex;
      flex-direction: row;
      div {
        &:first-child {
          margin-right: 20px;
        }
        width: 120px;
        height: 50px;
        line-height: 50px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
      }
      .view-btn {
        line-height: 48px;
        background-image: linear-gradient(
          41.94400710581127deg,
          #00eb81 0%,
          #00c89d 100%
        );
        -webkit-background-clip: text; /* Safari/Chrome */
        background-clip: text;
        color: transparent;
        border: 1px solid rgba(0, 232, 132, 0.2);
      }
      .goon-btn {
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1),
          rgba(0, 200, 157, 1)
        );
        color: #fff;
      }
    }
  }
}
.page-container__h5 {
  min-height: 100vh;
  padding-bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    .header-back {
      width: 0.24rem;
      height: 0.3467rem;
      top: 50%;
      left: 0.4533rem;
    }
  }
  .page-content {
    flex: 1;
    width: 100%;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 3.2rem;
      height: 3.2rem;
      margin-top: 2.2667rem;
    }
    p {
      margin-top: 0.5333rem;
      font-weight: 600;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
    }
    .btn-box {
      width: 100%;
      height: 2.4rem;
      box-shadow: 0px -12px 32px 0px rgba(102, 116, 107, 0.1);
      border-radius: 0.64rem 0.64rem 0px 0px;
      position: fixed;
      bottom: 0;
      left: 0;
      margin-top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      div {
        &:first-child {
          margin-right: 0.56rem;
        }
        width: 4.4rem;
        height: 1.3333rem;
        line-height: 1.3333rem;
        border-radius: 0.32rem;
        font-weight: 600;
        font-size: 0.4267rem;
        text-align: center;
        cursor: pointer;
      }
      .view-btn {
        background-image: linear-gradient(
          41.94400710581127deg,
          #00eb81 0%,
          #00c89d 100%
        );
        -webkit-background-clip: text; /* Safari/Chrome */
        background-clip: text;
        color: transparent;
        border: 1px solid rgba(0, 232, 132, 0.2);
        line-height: 1.3067rem;
      }
      .goon-btn {
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1),
          rgba(0, 200, 157, 1)
        );
        color: #fff;
      }
    }
  }
}
.page-container__electron {
  min-height: 0;
  padding-bottom: 0;
  padding-top: 0;
  .header-back {
    position: fixed;
    width: 9px;
    height: 13px;
    top: 20px;
    left: 74px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-image: url("../../assets/images/group-activity/back-icon.png");
    cursor: pointer;
    z-index: 1999;
  }
}
</style>
